module.exports = __webpack_public_path__ + "static/media/eu.d8c51286.svg";